export default __webpack_public_path__ + "static/media/mini-logo.e5c297a0.jpg";